import { Location } from './location.model';

export class MediacalPractice {
  id: string;
  companyName: string;
  defaultConsultationPrice: number;
  defaultConsultationReason: string;
  officeAddress: string;
  city: string;
  postalCode: string;
  siret: string;
  locations: Location[];

  constructor(companyName?: string) {
    this.companyName = companyName;
    this.locations = [];
    if (companyName) {
      this.defaultConsultationPrice = 0;
      this.defaultConsultationReason = '';
      this.officeAddress = '';
      this.siret = '';
      this.city = '';
      this.postalCode = '';
      this.locations.push(new Location('Mon Lieu'));
    }
  }
}
